module.exports = __webpack_public_path__ + "img/Fondo_Menu_inferior_optimo.39de71a5.svg";